if (!customElements.get("custom-select")) {
  class ComponentCustomSelect extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.elBtn = this.querySelector(".custom-select-value");
      this.elList = this.querySelector(".custom-select-dropdown");
      this.elOptions = document.querySelectorAll(".custom-select-option");

      this.initSelect();
      this.initOptions();
    }
    initSelect() {
      let elWidth = this.getBoundingClientRect()
      this.elList.style.width = `${elWidth.width}px`
      this.elBtn.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.elList.classList.contains("hide")) {
          this.elList.classList.remove("hide");
          this.elBtn.classList.add("open");
        } else {
          this.elList.classList.add("hide");
          this.elBtn.classList.remove("open");
        }
      });
    }

    initOptions() {
      Array.from(this.elOptions).forEach((elOption) => {
        elOption.addEventListener("click", (event) => {
          event.preventDefault();
          this.elList.classList.add("hide");
          this.elBtn.classList.add("open");
          this.elBtn.innerHTML = elOption.dataset.value;
          var optionPrice = elOption.querySelector('.option-price') ? parseInt(elOption.querySelector('.option-price').innerHTML.replace('$', ''))*100 : 0;
          this.dispatchEvent(
            new CustomEvent("customChange", {
              bubbles: true,
              cancelable: true,
              detail: { variantId: elOption.dataset.id, variantPrice: optionPrice }
            })
          );
          this.mainElement.dispatchEvent(
            new CustomEvent("addonChange", {
              bubbles: true,
              cancelable: true,
              detail: { variantId: elOption.dataset.id, variantPrice: optionPrice }
            })
          );
        });
      });
    }
  }
  customElements.define("custom-select", ComponentCustomSelect);
}
